<template>
  <div
    class="social-share"
    @mouseover="toggleSocial(true)"
    @mouseleave="toggleSocial(false)"
  >
    <button
      class="social-share__social-btn"
      @click="toggleSocial"
      :aria-label="$t('header.socialSharing.icon')"
    >
      <icon
        class="social-share__social-btn__icon"
        data="@icon/share.svg"
        width="1.625rem"
        height="1.625rem"
      />
    </button>

    <transition name="fade">
      <div v-if="socialShown" class="social-share__content-wrapper">
        <div class="social-share__content">
          <button
            v-for="item of $tm('header.socialSharing.socialMedia')"
            :key="item.social"
            class="social-share__content__btn"
            :aria-label="item.social"
          >
            <ShareNetwork
              :network="item.social"
              :url="socialUrl"
              :title="$t('header.socialSharing.title')"
              :description="$t('header.socialSharing.title')"
            >
              <icon
                class="social-share__content__icon"
                :data="pageIcons[item.social]"
                width="1.625rem"
                height="1.625rem"
                color="var(--scala-grigi-gray-1)"
              />
            </ShareNetwork>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script setup>
import pageIcons from "@/assets/icons/icons.js";

import { ref } from "@vue/reactivity";

const socialShown = ref(false);
// TODO: what should this be?
const socialUrl = window.location.href;
// const socialUrl =
//   "https://interactive.thevisualagency.com/test/eni-digit-eni-storia/";

function toggleSocial(value) {
  socialShown.value = value;
}
</script>

<style lang="scss" scoped>
.social-share {
  position: relative;
  display: inline-block;

  &__social-btn {
    &__icon {
      color: $scala-grigi-gray_2;
      transition: color 0.3s linear;
    }
    &:hover {
      .social-share__social-btn__icon {
        color: $scala-grigi-gray-1;
      }
    }
    &:hover > .navbar__social-btn__icon {
      color: $scala-grigi-gray_1;
    }
  }

  &__content-wrapper {
    position: absolute;
    right: 0;
    top: 100%;
    padding-top: 1rem;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 0.5rem;

    background: $scala-grigi-white;
    box-shadow: 0px -2px 25px rgba(0, 0, 0, 0.15);
    border-radius: 100px;

    &__btn {
      padding: toRem(10) 1rem;

      &:hover {
        :deep(.svg-icon path) {
          fill: $primary-yellow;
        }
      }
    }
  }
}
</style>
